import HexView from '@/views/hexView/index'

export default HexView